export {}


declare global {
    interface Array<T> {
        last(): T;
        lastIndex(): number;
        equals<T>( a2 : Array<T> ): boolean;
        groupBy<T>( groupExtractor: (v:T) => string) : { [groupName:string]: T[] };
    }
}


if(!Array.prototype.last){
    Object.defineProperty(Array.prototype, "last", {
        enumerable: false, // pouchdb serialization will fail if enumerable (tries to serialize function)
        writable: true,
        value: function() { if (!this.length) return undefined; else return this[this.length - 1] }
    });
}

if(!Array.prototype.lastIndex){
    Object.defineProperty(Array.prototype, "lastIndex", {
        enumerable: false,
        writable: true,
        value: function() { if (!this.length) return -1; else return this.length - 1 }
    });
}

// compare two arrays item by item
if(!Array.prototype.equals) {
    Object.defineProperty(Array.prototype, "equals", {
        enumerable: false,
        writable: true,
        value: function<T>( a2 : Array<T> ) {
            if (!a2 || this.length != a2.length)
                return false;
            for (var i = 0, l=this.length; i < l; i++) {
                if (this[i] instanceof Array && a2[i] instanceof Array) {
                    if (!this[i].equals(a2[i]))
                        return false;       
                } else if (this[i] != a2[i]) { 
                    return false;   
                }           
            }       
            return true;
        }
    })
}


if(!Array.prototype.groupBy){
    Object.defineProperty(Array.prototype, "groupBy", {
        enumerable: false,
        writable: true,
        value: function<T>( f: (T)=>string ) { 
            return this.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
        }
    })
}

